<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Services de distribution" />
            <ServiceDistribution />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ServiceDistribution from '../Services/ServiceDistribution'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ServiceDistributionPage',
    components: {
        NavBar,
        PageTitle,
        ServiceDistribution,
        FooterComp,
    }
}
</script>